export default __webpack_public_path__ + "static/2-5f40f375955177c95e38c433f09cd70e.jpg";